<template>
    <footer class="bg-black pt-5">
        <div class="container-fluid">
            <div class="row py-5 p-lg-5 text-white mx-auto">
                <div class="col-lg-12 text-center px-3 px-lg-5">
                    <h3 class="ff-n27-bold text-uppercase mb-3">RECIBE INFORMACIÓN Y PROMOCIONES DE LA PARVA </h3>
                </div>
                <!--
                <div class="col-lg-5 text-center px-3 px-lg-5 mx-auto pt-5 pt-lg-0">
                    <h3 class="ff-n27-bold text-uppercase mb-3">DESCARGA LA APP</h3>
                </div>
                -->
            </div>
            <div class="row mt-5 px-3 px-lg-5 text-white"></div>
        </div>
  </footer>
</template>

<script>
    import cartMixin from '../mixins/cartMixin';
    import siteConfig from '../mixins/siteConfig';

    export default {
        mixins: [cartMixin, siteConfig],

        props: {
            hasStickyFooter: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            cardType: {
                type: Object,
                default() {
                    return {};
                }
            }
        },

        computed: {
            applySticketFooter () {
                if (window.location.pathname === this.getUrl('homeUrl') && this.count) {
                    return true;
                }

                return this.hasStickyFooter;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue